module.exports = __webpack_public_path__ + "static/media/18.974aaf19.jpg";